import { BomItemType, MaterialHeaderRow } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { BomItemPointer } from '../../../../model/Project/BomItemPointer'
import { bomItemSelector } from './bomItemSelector'

export const bomItemCuttingPlansSelector =
  (bomItemPointer: BomItemPointer) => (state: RootAppState) => {
    if (!bomItemPointer || !bomItemPointer.id) return null

    const bomItem = bomItemSelector(state, bomItemPointer)

    if (bomItem?.type === BomItemType.partType) {
      const headers = Object.values(state.project.materialHeaders || {}).filter(
        (x) => x.type === BomItemType.materialHeader,
      ) as MaterialHeaderRow[]

      const cuttingPlans = headers.flatMap((x) =>
        x.cuttingPlans?.filter((plan) =>
          plan.partTypeIds.includes(bomItemPointer.id),
        ),
      )

      return cuttingPlans
    }

    return null
  }

export const bomItemHasCuttingPlansSelector =
  (bomItemPointer: BomItemPointer) => (state: RootAppState) => {
    const cuttingPlans = bomItemCuttingPlansSelector(bomItemPointer)(state)
    return cuttingPlans && cuttingPlans.length > 0
  }
